import React from 'react';
import {Link as RouterLink, useMatches} from 'react-router-dom';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import MuiLink from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

interface Crumb {
    label: string;
    to: string | null;
}

interface CrumbHandle {
    crumb: (data: unknown) => Crumb | Crumb[];
}

function hasCrumb(handle: unknown): handle is CrumbHandle {
    return (
        typeof handle === 'object' &&
        handle !== null &&
        'crumb' in handle &&
        typeof (handle as Record<string, unknown>).crumb === 'function'
    );
}

export function AppBreadcrumbs() {
    const matches = useMatches();
    const crumbs = matches
        .filter(m => hasCrumb(m.handle))
        .flatMap(m => {
            const result = (m.handle as CrumbHandle).crumb(m.data);
            return Array.isArray(result) ? result : [result];
        });

    if (crumbs.length === 0) return null;

    return (
        <Box sx={{px: 2, py: 0.75, bgcolor: 'background.paper', borderBottom: 1, borderColor: 'divider'}}>
            <Breadcrumbs>
                {crumbs.map((crumb, i) =>
                    i < crumbs.length - 1 && crumb.to ? (
                        <MuiLink key={i} component={RouterLink} to={crumb.to} underline="hover" color="inherit">
                            {crumb.label}
                        </MuiLink>
                    ) : (
                        <Typography key={i} color="text.primary" variant="body2">
                            {crumb.label}
                        </Typography>
                    )
                )}
            </Breadcrumbs>
        </Box>
    );
}
